'use strict';

const LEFT_SYMBOL = '&#10094;';
const RIGHT_SYMBOL = '&#10095;';

class Slider {
  col = 4;
  delay = 6000;
  isSliding = false;
  isInPlay = false;
  noOfCols = { mobile: 1, tablet: 2, desktop: 3 };
  pauseOnHover = true;
  slider = null;
  sliderWidth;
  interval;
  gap;
  lastTime;
  timeLapse = 0;

  constructor(sliderEl) {
    this.slider = sliderEl;
	this.pauseVideos();
    this.setDelay();
    this.setSliderWidth();
    this.setGap();
    this.setNoOfColumns();
    this.setResponsiveColumns();
    this.addNavigation();
    this.addEmptySlides();
    this.setSlideMargin();
    this.setPauseOnHover();
    this.onResize();
    this.onMouseHover();
  }

  addEmptySlides() {
    const slides = this.slider.querySelectorAll('.slide');
    const noOfLastSlides = slides.length % this.col;
    const addSlides = noOfLastSlides ? this.col - noOfLastSlides : 0;
    for (let i = 0; i < addSlides; i++) {
      const li = document.createElement('li');
      li.classList.add('slide', 'empty');
      const figure = document.createElement('figure');
      li.appendChild(figure);
      this.slider.querySelector('.slides').appendChild(li);
    }
  }

  addNavButton(nav, className, text) {
    const button = document.createElement('button');
    button.classList.add(className);
    button.innerHTML = text;
    nav.appendChild(button);

    return button;
  }

  addNavigation() {
    const slides = this.slider.querySelector('.slide');
    if (slides.length <= this.col) return;

    const nav = document.createElement('nav');

    const leftButton = this.addNavButton(nav, 'left', LEFT_SYMBOL);
    leftButton.addEventListener('click', this.leftClick.bind(this));

    const rightButton = this.addNavButton(nav, 'right', RIGHT_SYMBOL);
    rightButton.addEventListener('click', this.rightClick.bind(this));

    this.slider.appendChild(nav);
  }

  leftClick() {
    if (this.isSliding) return;

//     clearInterval(this.interval);
    this.stopSliding();
    this.slideLeft();
    this.play();
  }

  rightClick() {
    if (this.isSliding) return;

//     clearInterval(this.interval);
    this.stopSliding();
    this.slideRight();
    this.play();
  }

  onMouseHover() {
    if (!this.pauseOnHover) return;

    this.slider.addEventListener('mouseover', () => {
//       clearInterval(this.interval);
	  this.stopSliding();
      this.isInPlay = false;
    });
    this.slider.addEventListener('mouseout', () => {
      if (this.isInPlay) return;

      this.play()
    });
  }

  onResize() {
    window.addEventListener('resize', () => {
      this.setResponsiveColumns();
      this.removeEmptySlides();
      this.addEmptySlides();
      this.setSlideMargin();
      this.setSliderWidth();
    });
  }

  play() {
    this.isInPlay = true;
    this.lastTime = 0;
//     this.interval = setInterval(() => this.slideLeft(), this.delay);
    // window.requestAnimationFrame(this.slide.bind(this));
    this.interval = window.requestAnimationFrame(this.slide.bind(this));
  }

  pauseVideos() {
  	const videos = this.slider.querySelectorAll('video');
    videos.forEach(video => video.pause());
  }

  removeExistingColumnClass() {
    const entries = Object.entries(this.noOfCols)
    entries.forEach(entry => this.slider.classList.remove(`col-${entry[1]}`));
  }

  removeEmptySlides() {
    const slides = this.slider.querySelectorAll('.slide.empty');
    slides.forEach(slide => slide.remove());
  }

  setDelay() {
    const delay = this.slider.dataset.delay;
    if (delay) this.delay = delay;
  }

  setGap() {
    this.gap = window.getComputedStyle(this.slider).getPropertyValue('--gap');
  }

  setNoOfColumns() {
    const devices = ['Mobile', 'Tablet', 'Desktop']
    devices.forEach(device => {
      if (`col${device}` in this.slider.dataset === false) return;

      const value = this.slider.dataset[`col${device}`];
      this.noOfCols[device.toLowerCase()] = +value;
    });
  }

  setPauseOnHover() {
    const pause = this.slider.dataset.pauseOnHover;
    this.pauseOnHover = pause === '' || pause === 'true' ? true : false;
  }

  setResponsiveColumns() {
    const mediaQueries = [
      { breakpoint: 'screen and (max-width: 599px)', col: this.noOfCols.mobile },
      { breakpoint: 'screen and (min-width: 600px)', col: this.noOfCols.tablet },
      { breakpoint: 'screen and (min-width: 960px)', col: this.noOfCols.desktop },
    ];
    mediaQueries.forEach(query => {
      const media = window.matchMedia(query.breakpoint);
      if (media.matches) this.col = query.col;
    });
    this.setStyle();
  }

  setStyle() {
    this.removeExistingColumnClass();
    this.slider.style.setProperty('--no-of-col', this.col);
      this.slider.classList.add('col-' + this.col);
  }

  setSliderWidth() {
    this.sliderWidth = this.slider.offsetWidth;
  }

  setSlideMargin() {
    const slides = this.slider.querySelectorAll('.slide');
    slides.forEach(slide => slide.style.marginLeft = 0);
    if (this.col > 1) {
      const slides = this.slider.querySelectorAll('.slide:not(:nth-of-type(' + this.col + 'n + 1)');
      slides.forEach(slide => slide.style.marginLeft = this.gap);
    }
  }

  slideLeft() {
    this.isSliding = true;
    this.isInPlay = true;
    const container = this.slider.querySelector('.slides');
    const slides = container.querySelectorAll('.slide');
    const firstSlide = slides[0];
    firstSlide.style.marginLeft = `-${this.sliderWidth}px`;
    setTimeout(() => {
      for (let i = 0; i < this.col; i++) {
        container.append(slides[i]);
      }
      firstSlide.style.marginLeft = 0;
      this.isSliding = false;
    }, 500);
  }

  slideRight() {
    this.isSliding = true;
    this.isInPlay = true;
    const container = this.slider.querySelector('.slides');
    const slides = container.querySelectorAll('.slide');
    const firstSlide = slides[slides.length - this.col];
    firstSlide.style.marginLeft = `-${this.sliderWidth}px`;
    for (let i = 1; i <= this.col; i++) {
      container.prepend(slides[slides.length - i]);
    }
    setTimeout(() => {
      firstSlide.style.marginLeft = 0;
      this.isSliding = false;
    }, 0);
  }

  slide(time) {
    if(this.lastTime) {
      const delta = time - this.lastTime;
      this.timeLapse = this.timeLapse + delta;
      if (this.timeLapse >= this.delay)  {
        this.timeLapse = 0;
        this.slideLeft();
      }
    }

    this.lastTime = time;
    this.interval = window.requestAnimationFrame(this.slide.bind(this));
  }

  stopSliding() {
    if (this.interval) {
      window.cancelAnimationFrame(this.interval); 
    }
    this.interval = undefined;
    this.timeLapse = 0;
    this.lastTime = 0;
  }
}


const sliders = document.querySelectorAll('.slider');
const posterObserver = new IntersectionObserver(setPosterURL, { rootMargin: '415px', });
sliders.forEach(slider => {
  new Slider(slider).play();
  posterObserver.observe(slider);
    
  const slides = slider.querySelectorAll('.slide');
  slides.forEach(slide => {
    slide.addEventListener('mouseenter', playVideoOnMouseHover);
    slide.addEventListener('mouseleave', pauseVideoOnMouseLeave);
    slide.addEventListener('touchstart', playVideoOnTouch);
  });
  
  showVideoLoading(slider);
  hideVideoLoading(slider);
  showPlayButton(slider);
  hidePlayButton(slider);
  playVideo(slider);
});

async function playVideoOnMouseHover(e) {
  const slide = e.target;
  const video = slide.querySelector('video');
  try {
  	await video.play();
  } catch(err) {
    video.muted = true;
    video.play();
  }
}

async function pauseVideoOnMouseLeave(e) {
  const slide = e.target;
  const video = slide.querySelector('video');
  try {
  	await video.play();
   	video.pause();
   	video.controls = false;
  } catch(err) {
	console.log(err)
  }
}

async function playVideoOnTouch(e) {
  const slide = e.target.parentElement;
  const video = e.targetTouches.length > 1
  	? e.targetTouches.item(0).target
    : e.touches.item(0).target;
  if (video.nodeName !== 'VIDEO') return;
  
  try {
      await video.play();
  	} catch(err) {
      video.muted = true;
      video.play();
  	}
}
  
function showVideoLoading(slider) {
  const videos = slider.querySelectorAll('video');
  videos.forEach(video => {
    video.addEventListener('waiting', () => {
      video.parentElement.parentElement.classList.add('loading');
  	});
  });
}

function hideVideoLoading(slider) {
  const videos = slider.querySelectorAll('video');
  videos.forEach(video => {
    video.addEventListener('playing', () => {
      video.parentElement.parentElement.classList.remove('loading');
  	});
  });
}

function showPlayButton(slider) {
  const videos = slider.querySelectorAll('video');
  videos.forEach(video => {
  	video.addEventListener('pause', () => {
      video.parentElement.parentElement.classList.remove('play');
  	});
  
    video.addEventListener('play', () => {
        video.parentElement.parentElement.classList.add('play');
    });
  });
}

function hidePlayButton(slider) {
  const videos = slider.querySelectorAll('video');
  videos.forEach(video => {
    video.addEventListener('waiting', () => {
      video.parentElement.parentElement.classList.add('play');
  	});
  	video.addEventListener('playing', () => {
      video.parentElement.parentElement.classList.add('play');
  	});
  });
}

function playVideo(slider) {
  const buttons = slider.querySelectorAll('.play-button');
  buttons.forEach(button => {
    button.addEventListener('click', async () => {
      const a = button.parentElement;
      const video = a.querySelector('video');
      try {
        await video.play();
      } catch(err) {
        video.muted = true;
        video.play();
      }
    });
  });
}

function setPosterURL(entries) {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    
    const slider = entry.target;
    const videos = slider.querySelectorAll('.slide video');
  	videos.forEach(video => {
      const poster = video.dataset.posterUrl;
      video.poster = poster;
    });
    posterObserver.unobserve(slider);
  });
}